import { render, staticRenderFns } from "./PerformanceFormulaSelect.vue?vue&type=template&id=4c42c003"
import script from "./PerformanceFormulaSelect.vue?vue&type=script&lang=js"
export * from "./PerformanceFormulaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports